import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=adf0ad88"
import script from "./Contracts.vue?vue&type=script&lang=js"
export * from "./Contracts.vue?vue&type=script&lang=js"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=adf0ad88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports